import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
// import StatusA from './StatusA';
import StatusB from './StatusB';
import styles from './index.module.scss';
import EfScrollAni from '@/efscrollani';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={styles.pageProduct}>
            {/* {pageStatus === IPageStatus.statusA && <StatusA />} */}
            {pageStatus === IPageStatus.statusB && <StatusB />}
        </div>
    );
}
